<template>
	<div class="chatting-send-input" id="chatting-send-input" contenteditable="true" v-html="showMsg"
	@input="changeText"  
	@focus="inputFocus(1)" 
	@blur="inputFocus(0)">
	</div>
</template>

<script>
	import {filterInput} from '../functions/Common.js'
	
	export default {
		name:'ChattingInput',
		props:{
			// 工具栏数据，包括上传图片，视频，快捷语等
			chatToolsData:{
				type: Object,
				default:function(){
					return {}
				}
			},
			// 发送按钮的id，用于enter提交
			sendButtonId:{
				type:String,
				default:'chatting-send-submit'
			},
			// 是否修改原始的enter功能
			modifyEnter:{
				type:Boolean,
				default: false
			},
			
			// 默认消息
			defaultMsg:{
				type: String,
				default: ''
			}
		},
		data(){
			return {
				message:'',
				showMsg:'',
				imgList:[],
				messageList:[]
			}
		},
		methods:{
			// 内容变化时触发
			changeText(changeMsg){
				if(changeMsg !== true){
					this.message = this.$el.innerHTML
					if(this.message === '<br>' || this.message === ''){
						this.showMsg = ''
						this.message = ''
					}
				}
				this.messageList = filterInput(this.message)
				this.$emit('chat-input-msg',this.messageList)
			},
			
			// 聚焦时触发
			inputFocus(val){
				this.$emit('chat-input-focus',val)
			},
			
			// 清空输入框的数据
			clearInput(){
				this.message = ''
				this.showMsg = ''
				this.imgList = []
				this.messageList = []
				this.$el.innerHTML = ''
			},
			
			
			// 光标位置解决
			cursorPosition(){
				let obj = document.getElementById('chatting-send-input'),select = window.getSelection()
				select.selectAllChildren(obj)
				select.collapseToEnd()
			}
		},
		watch:{
			// 监听工具栏传入的参数-包括工具栏和快捷语
			chatToolsData(nVal){
				if(nVal.type !== undefined){
					// 上传的图片
					if(nVal.type === "image"){
						for (let i = 0; i < nVal.data.length; i++) {
							if(this.imgList.indexOf(nVal.data[i]) === -1){
								this.imgList.push(nVal.data[i])
								this.message += "<img src='"+nVal.data[i]+"'>"
							}
						}
					}
					// 上传的视频
					else if(nVal.type === "video"){
						if(nVal.data.length  > 0){
							this.message += '&nbsp;<video src="'+nVal.data[0]+'" controls="controls"></video>&nbsp;'
						}
					}
					// emoji 点击数据
					else if(nVal.type === "emoji"){
						this.message += "<img src='"+nVal.data.path+"'>"
					}
					// 快捷语点击-图片类型
					else if(nVal.type === "replyImage"){
						this.message += "<img src='"+nVal.content+"'>"
					}
					// 快捷语点击-文字类型
					else if(nVal.type === "replyText"){
						this.message += "<div>"+nVal.content+"</div>"
					}else if(nVal.type === "clusterMember"){
						this.message += "@"+nVal.data.friends_wx_name+" "
					}else{
						return
					}
					this.showMsg = this.message
					// dom更新后在执行
					this.$nextTick(()=>{
						this.changeText(true)					
					})
				}
			},
			
			defaultMsg(nVal){
				this.showMsg = '<div>'+nVal+'</div>'
				this.message = nVal
			}
		},
		mounted() {
			// 消息输入框Ctrl+Enter换行
			if(this.modifyEnter){
				let _this = this
				document.getElementById('chatting-send-input').onkeyup = function(event){
					var ctrlKey = event.ctrlKey;
					var keyCode = event.keyCode || event.which;
					if (ctrlKey && keyCode == 13){
						_this.message += '<div><br></div>'
						_this.showMsg = _this.message
						// dom更新后在执行
						_this.$nextTick(()=>{
							_this.cursorPosition()			
						})	
					}
					event.preventDefault();
					return false;
				}
				
				// Enter 发送
				document.getElementById('chatting-send-input').onkeydown = function(event){
					var ctrlKey = event.ctrlKey;
					var keyCode = event.keyCode || event.which;
					if (ctrlKey == false && keyCode == 13){
						document.getElementById(_this.sendButtonId).click()
						event.preventDefault();
						return false;
					}
				}
			}
		}
	}
</script>

<style>
	.chatting-send-input{
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		border: 1px solid #CCCCCC;
		outline: none;
		border-radius: 4px;
		resize: none;
		user-select: all;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chatting-send-input:focus{
		border: 1px solid #42B983;
	}
	.chatting-send-input img{
		max-width: 120px;
		height: auto;
		margin: 2px;
		display: inline-block;
	}
	.chatting-send-input video{
		max-width: 200px;
		height: auto;
		margin: 2px;
	}
</style>
